import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IVehicleList } from "../../../Pages/Vehicle/Ivehicle";

export const AddVehicleSlicer = createSlice({
  name: "AddVehicle",
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<IVehicleList>,
  reducers: {
    addVehicle: (state, _) => {
      state.isLoading = true;
    },
    successAddVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureAddVehicle: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearAddVehicleState: (state) => {
      state.data = {};
    },
  },
});

export const {
  addVehicle,
  failureAddVehicle,
  successAddVehicle,
  clearAddVehicleState,
} = AddVehicleSlicer.actions;

export default AddVehicleSlicer.reducer;
